namespace TabAurous.Stock {
    export namespace WorkOrderStockService {
        export const baseUrl = 'Stock/WorkOrderStock';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetProductDetails(request: ProductRequest, onSuccess?: (response: Serenity.RetrieveResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/WorkOrderStock/List",
            GetProductDetails = "Stock/WorkOrderStock/GetProductDetails"
        }

        [
            'List', 
            'GetProductDetails'
        ].forEach(x => {
            (<any>WorkOrderStockService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
